import React, {Component} from 'react';
import Moment from 'react-moment';
import './TenderWonEvent.css';

class TenderWonEvent extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        data: {
            tenderId: 1,
            tenderNumber: '0012',
            tenderSum: 220,
            tenderWonSeq: 12,
            deliveryDate: (new Date()).toString(),
            timestamp: (new Date()).toString()
        }
    };

    render() {
        const { data, ...state } = this.state;
        return (
            <div className="widget-notifications-item">
                <div className="widget-notifications-title text-success font-size-13">Вы выиграли!</div>
                <div className="widget-notifications-description font-size-13">
                    Вы выиграли <a href="#">тендер № <strong>{data.tenderNumber}</strong></a> на сумму {data.tenderSum} тыс. руб. с доставкой <strong>
                        <Moment format="DD MMMM YYYY" locale="ru">{data.deliveryDate}</Moment>
                    </strong> <small>(<a href="#">посмотреть в календаре?</a>)</small>.
                    <br />
                    Продолжайте в том же духе &mdash; это ваш <strong>{data.tenderWonSeq}й</strong> выигранный тендер.
                </div>
                <div className="widget-notifications-date font-size-12">
                    <Moment fromNow locale="ru">{data.timestamp}</Moment>
                </div>
                <div className="widget-notifications-icon fa fa-thumbs-up bg-success"></div>
            </div>
        );
    }
}

export default TenderWonEvent;


// WEBPACK FOOTER //
// ./src/pages/EventsFeed/TenderWonEvent.js